import {
    ActivityCategory,
    ActivityRecordType,
    activityRecordTypeForGoalMetricItemLinkKind,
    activityRecordTypes,
    GoalMetricItemLink,
    TaskTypeId,
} from "@sp-crm/core";
import { format } from "date-fns";

export interface MyActivityItem {
    id: string;
    category: ActivityCategory;
    taskTypeId: TaskTypeId | null;
    kind: "touchpoint" | "visit" | "task";
    sourceId: string | null;
    label: string;
    chipLabel: string | null;
    text: string | null;
    noteText: string | null;
    date: string;
    time: string;
    parentName: string | null;
    note: string | null;
    link: GoalMetricItemLink | null;
}

export interface MyActivityDay {
    date: string;
    items: MyActivityItem[];
}

export interface MyActivityRange {
    startDate: string;
    endDate: string;
}

export const todayRange = (today: Date): MyActivityRange => ({
    startDate: format(today, "yyyy-MM-dd"),
    endDate: format(today, "yyyy-MM-dd"),
});

export const myActivityRecordType = (item: MyActivityItem): ActivityRecordType | null =>
    item.link ? activityRecordTypeForGoalMetricItemLinkKind[item.link.kind] : null;

export const availableActivityRecordTypes = (
    items: MyActivityItem[],
): ActivityRecordType[] => {
    const present = new Set(
        items
            .map(myActivityRecordType)
            .filter(
                (recordType): recordType is ActivityRecordType => recordType !== null,
            ),
    );
    return activityRecordTypes.filter(recordType => present.has(recordType));
};

export const filterActivityByRecordType = (
    items: MyActivityItem[],
    selected: ActivityRecordType[],
): MyActivityItem[] => {
    if (selected.length === 0) {
        return items;
    }
    return items.filter(item => {
        const recordType = myActivityRecordType(item);
        return recordType !== null && selected.includes(recordType);
    });
};

export const groupActivityByDate = (items: MyActivityItem[]): MyActivityDay[] => {
    const days: MyActivityDay[] = [];
    const byDate = new Map<string, MyActivityDay>();
    for (const item of items) {
        const existing = byDate.get(item.date);
        const day = existing ?? { date: item.date, items: [] };
        if (!existing) {
            byDate.set(item.date, day);
            days.push(day);
        }
        day.items.push(item);
    }
    return days;
};
